import axios from "axios";
import { hostname } from "src/HostName";

const uploadInstance = axios.create({
  baseURL: hostname,
});
export const uplodaAirlineFileApi = async (formData) =>
  uploadInstance.post("upload/airlineExcel/data", formData);
export const getAirlineExcelApi = async (page = 1, limit = 10) =>
  uploadInstance.get(`api/v1/airlines/exceldata?page=${page}&limit=${limit}`);

export const updateAirlineFileApi = async (data) =>
  uploadInstance.patch("edit/excel/data", data);
export const deleteAirlineFileApi = async (id) =>
  uploadInstance.delete(`delete/airline/excel/data?_id=${id}`);
export const bulkPriceFileApi = async (price) =>
  uploadInstance.patch(`bulkedit/airline/excel/data?amount=${price}`);
export const bulkUpdateDateFileApi = async (date, type = "departDate") =>
  uploadInstance.patch(`bulkedit/airline/excel/date?${type}=${date}`);
